import { removeCharacters } from "@/lib/custom-validations"
import type { PersonPFFormData } from "../types/person-pf"
import type { PersonPJFormData } from "../types/person-pj"
import type { PersonPersonalizationFormData } from "../types/person-personalization"
import type { AddressPerson, BankAccountPerson, Custom, HealthPerson, JuridicPerson, Profile } from "@/types/person"

/** Converte DD/MM/YYYY para ISO string. Retorna null se inválido ou vazio. */
function parseDateBR(value: string | undefined | null): string | null {
  if (!value) return null
  const parts = value.split("/")
  if (parts.length !== 3) return null
  const [day, month, year] = parts
  const date = new Date(`${year}-${month}-${day}T00:00:00.000Z`)
  if (isNaN(date.getTime())) return null
  return date.toISOString()
}

export function transformPFFormToProfile(data: PersonPFFormData): Profile {
  return {
    name: data.completeName,
    social_name: data.socialName || "",
    artistic_name: data.artisticName || "",
    role: data.role,
    rg_number: removeCharacters(data.rg),
    document: removeCharacters(data.cpf),
    birth_date: parseDateBR(data.birthDate) ?? "",
    place_of_birth: data.birthPlace,
    nationality: data.nationality,
    brazil_arrival_date: parseDateBR(data.countryEntryDate),
    id_civil_state: parseInt(data.maritalStatus),
    id_pronouns: parseInt(data.pronouns),
    cellphone_number: data.cellphone,
    tshirt_number: data.tshirtNumber || "",
  }
}

export function transformPFFormToAddress(data: PersonPFFormData): AddressPerson {
  return {
    id: 0,
    neighbourhood: data.neighborhood,
    place_of_birth: data.birthPlace,
    address: data.residentialAddress,
    postal_code: data.zipCode,
  }
}

export function transformPFFormToHealth(data: PersonPFFormData): HealthPerson {
  return {
    id: 0,
    health_plan_name: data.healthPlan || "",
    health_plan_coverage: data.planCoverage || "",
    emergency_contact: data.emergencyContact || "",
    blood_type: data.bloodType || "",
    allergies: data.allergies || "",
    covid_vaccine: data.coronavirusVaccination || "",
    dietary_restrictions: data.dietaryRestrictions || "",
  }
}

export function transformPFFormToBank(data: PersonPFFormData): BankAccountPerson {
  return {
    id: 0,
    id_incentive_law: 1,
    bank_name: data.bank || "",
    bank_account: data.checkingAccount || "",
    agency: data.branch || "",
    active: true,
    is_juridic: false
  }
}

export function transformPJFormToJuridic(data: PersonPJFormData): JuridicPerson {
  return {
    id: 0,
    company_name: data.companyName,
    document: removeCharacters(data.cnpj),
    address: data.businessAddress,
    neighbourhood: data.businessDistrict,
    city_state: data.businessCityState,
    postal_code: data.businessZipCode,
    cnaes: data.cnaeCode,
    municipal_register: data.municipalRegistration || "",
    ancine_number: data.ancineRegistrationNumber || "",
  }
}

export function transformPJFormToBank(data: PersonPJFormData): BankAccountPerson {
  return {
    id: 0,
    id_incentive_law: 1,
    bank_name: data.bankName || "",
    bank_account: data.checkingAccount || "",
    agency: data.bankBranch || "",
    active: true,
    is_juridic: true
  }
}

export function transformPersonalizationToCustom(
  data: PersonPersonalizationFormData,
  juridic: boolean
): Custom {
  return {
    biography: juridic ? data.companyDescription || "" : data.userDescription || "",
    url_avatar: juridic ? data.companyProfileImage || "https://av.com" : data.userProfileImage || "https://av.com",
    url_facebook: juridic ? data.companyFacebookUrl || "https://fc.com" : data.userFacebookUrl || "https://fc.com",
    url_x: juridic ? data.companyTwitterUrl || "https://x.com" : data.userTwitterUrl || "https://x.com",
    url_linkedin: juridic ? data.companyLinkedinUrl || "https://linkedin.com" : data.userLinkedinUrl || "https://linkedin.com",
    url_instagram: juridic ? data.companyInstagramUrl || "https://ins.com" : data.userInstagramUrl || "https://ins.com",
    juridic,
  }
}
